import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  basketDetailsAction,
  createBasketsAction,
  resetBasketAction,
  resetValidateBasketAction,
  setUserLastActiveTime,
  showCustomizationModalAction,
  validateBasketAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import first from 'lodash/first';
import get from 'lodash/get';
import { getStoreStatusForTimeSaga } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import getContentHelpCall from '@kfc-global/react-shared/redux/Actions/HelpAction';
import { fetchMenuAction, recommendedProductAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { ChannelManager } from 'common/manager';
import CartPageComponent from 'organisms/CartPage/AU/Container/CartPageComponent';
import CART_STATES_CONSTANTS from 'organisms/CartStatesModule/Constants/CartStatesConstants';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { MENU_PLP_CONSTANT_DATA } from 'common/utilities/menuPLPModulator';
import ProductListingModalOptions from 'organisms/ProductListingModalOptions/Container/ProductListingModalOptionsComponent';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { getCmsClient } from 'common/utilities/cmsClient';
import { setPriceLimitInLocalStorage } from 'organisms/CartPage/AU/Utils/cartPageUtils';
import {
  bufferTimeFn,
  createBasketData,
  getDispositionTypeOnAPIFormat,
  getFaqData,
  getPrice,
  getTotalprice,
  getValueOrnull,
  ifCheckoutAmountFailure,
  ifCheckoutItemFailure,
  isEmptyEvery,
  isEqualDisposition,
  triggerCartModel,
  getTernaryValue,
  getValueOrDefaultObject,
  createPayloadForStatusCall,
  isMobileDevice,
  getBackgroundImagePath,
  redirectToCheckoutPage,
  isValidObject,
  checkModifiersAvailability,
  checkTimeDuration,
  filterExcludedItem,
  checkForClickAndCollect,
  isFutureDate,
  isFutureTime,
  isDeliveryDisposition,
} from 'common/utilities/utils';
import { storeOrderSchedulingUnavailable } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { UserOrderContext } from 'context/context';
import {
  LOCAL_STORAGE_KEYS,
  RESIZE,
  CART_SELECT_STORE_MSG,
  DOORDASH_NOT_SERVICEABLE,
  STREET_NUMBER,
} from 'common/constants/SharedConstants';
import AlertContainer from 'organisms/AlertComponent/Container/AU/AlertContainer';

import { resetOrderAction, createOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import { resetPostOrder } from '@kfc-global/react-shared/redux/Actions/PostOrderAction';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { saveScheduleDate } from 'organisms/MenusPLP/AU/MenusPlpUtilities/MenusPlpUtils';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { getPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
const { CART_STATES_DATA, DISPOSITION_CHANGED_FLAG, STORE_CHANGED_FLAG, NOT_WITHIN_OPERATING_HOURS, CLOSED } =
  START_ORDER_CONSTANTS;
const { FROMCONFIRM } = CART_STATES_CONSTANTS;
export const analyzeFoodLine = FoodLineParams => {
  const itemfromCart = JSON.parse(JSON.stringify(FoodLineParams.foodLineItem));
  const mapToReturn = {
    toRemove: true,
    requireModification: false,
    findings: ['Item not available'],
    newFoodLineItem: itemfromCart,
    menuPrice: undefined,
    cartPrice: itemfromCart.amount / FoodLineParams.currencyConversionFactor,
    taxLines: FoodLineParams.taxLines,
  };
  const flatItem = FoodLineParams.menuJSONData?.[itemfromCart?.item?.id];
  if (flatItem) {
    mapToReturn.findings = [];
    mapToReturn.toRemove = checkModifiersAvailability(itemfromCart?.item, FoodLineParams.exclusionsResponse);
    const getPriceFromMenu = getPrice(flatItem.availability[0], FoodLineParams.currencyConversionFactor);
    const cartPrice = itemfromCart.amount / FoodLineParams.currencyConversionFactor;
    const priceFromMenu = getTotalprice(
      getPriceFromMenu,
      itemfromCart.item.modGrps,
      itemfromCart.quantity,
      FoodLineParams.currencyConversionFactor,
    );
    if (priceFromMenu !== cartPrice) {
      mapToReturn.findings.push(`Item Price has changed Cart Price(${cartPrice}), Menu price(${priceFromMenu})`);
      mapToReturn.requireModification = true;
      mapToReturn.menuPrice = priceFromMenu;
      mapToReturn.cartPrice = cartPrice;
      // If the price has changed pick the item from the new Menu
    } else {
      mapToReturn.menuPrice = priceFromMenu;
      mapToReturn.cartPrice = cartPrice;
      // If the price has not changed use the cart line item as it is
      mapToReturn.newFoodLineItem = itemfromCart;
    }
  }
  return mapToReturn;
};
export const defaultFoodLine = (foodLineItem, currencyConversionFactor) => {
  const itemfromCart = JSON.parse(JSON.stringify(foodLineItem));
  return {
    toRemove: false,
    requireModification: false,
    findings: [],
    newFoodLineItem: itemfromCart,
    menuPrice: undefined,
    cartPrice: itemfromCart.amount / currencyConversionFactor,
  };
};

export const checkSummaryStatus = (storeSummaryDetail, setStoreClosedMsg, setShowAlert) => {
  if (!storeSummaryDetail) {
    setStoreClosedMsg(CLOSED);
    setShowAlert(true);
  }
};
const switchErrorMsg = (storeClosedMsg, doordashNotAvailable = DOORDASH_NOT_SERVICEABLE) => {
  return storeClosedMsg ? doordashNotAvailable : storeClosedMsg;
};

const cartValidationCheck = params => {
  const {
    dispatch,
    isValidated,
    navigateToCheckOutObj,
    validationResult,
    validationObj,
    setMenuCallBack,
    basketId,
    tenantId,
    customerId,
    setIsLoadOrderReducer,
    getPwaStorageData,
    checkPassStreetNumber,
    service,
  } = params;
  let { fromFlag } = navigateToCheckOutObj;
  if (isValidated) {
    setIsLoadOrderReducer(true);
    const orderPayLoad =
      checkPassStreetNumber && isDeliveryDisposition(service)
        ? {
            basketId,
            customProperties: [
              {
                key: STREET_NUMBER,
                value: getPwaStorageData?.streetNumber,
              },
            ],
          }
        : { basketId };
    !fromFlag &&
      dispatch(
        createOrderAction({
          tenantId,
          customerId,
          request: orderPayLoad,
        }),
      );
  } else {
    ifCheckoutAmountFailure(validationResult, validationObj);
    !ifCheckoutItemFailure(validationResult) && setMenuCallBack(false);
  }
};

const cartIdAndTenantIdExists = (cartData, tenantId, menuCallBack) => {
  return cartData?.id && tenantId && !menuCallBack ? true : false;
};

const checkExclusion = (recommendedItems, exclusionsResponse, NA) => {
  if (recommendedItems?.length > 0 && exclusionsResponse?.length > 0) {
    filterExcludedItem(recommendedItems, exclusionsResponse, NA);
  }
};
export const confirmChangesSubmit = payload => {
  const { unavailableItems, priceChangedItems, createAddValidateBasket, dispatch, cartId, tenantId } = payload;
  if (unavailableItems.length || priceChangedItems.length) {
    createAddValidateBasket();
  } else {
    //validate basket
    dispatch(validateBasketAction({ data: { id: cartId }, tenantId: tenantId }));
  }
};
const checkForScheduleOrder = (scheduleTimeCheck, enableScheduleOrder, setOrderScheduleModal) => {
  if (scheduleTimeCheck && enableScheduleOrder) {
    setOrderScheduleModal(true);
    return true;
  }
  return false;
};

const confirmChangesHandler = confirmChangesParam => {
  const {
    type,
    storeDetails,
    buffertimepmdelivery,
    buffertimepmpickup,
    cartWarningMsg,
    setStoreClosedMsg,
    setShowAlert,
    setOnModalOpen,
    setFromFlag,
    dispatch,
    unavailableItems,
    priceChangedItems,
    cartData,
    tenantId,
    createAddValidateBasket,
    scheduleTimeCheck,
    setOrderScheduleModal,
    enableScheduleOrder,
    enableClickCollectScheduleOrder,
    isFutureDateTimeOrder,
    enableScheduleOrderFlag,
  } = confirmChangesParam;
  const bufferTiming = storeDetails && bufferTimeFn(storeDetails[0]?.service, buffertimepmdelivery, buffertimepmpickup);

  if (checkForScheduleOrder(scheduleTimeCheck, enableScheduleOrder, setOrderScheduleModal)) {
    return;
  }
  if (cartWarningMsg) {
    const stoerSummary = get(first(storeDetails), 'summary', {});
    const calculateTimeDiff = bufferTiming && checkTimeDuration(stoerSummary, bufferTiming);
    const storeStatus = get(stoerSummary, 'status', {});
    const message = get(storeStatus, 'message', '');
    if (!enableScheduleOrderFlag && calculateTimeDiff?.timingFlag && get(storeStatus, 'currentStatus', '') !== CLOSED) {
      setStoreClosedMsg(null);
      setShowAlert(true);
      return;
    }
    if (
      checkForClickAndCollect({
        scheduleTimeCheck,
        enableClickCollectScheduleOrder,
        storeStatus,
        setOrderScheduleModal,
        setShowAlert,
        cartData,
        storeSummary: stoerSummary,
        isFutureDateTimeOrder,
      })
    ) {
      return;
    }
    if (!enableClickCollectScheduleOrder && get(storeStatus, 'currentStatus', '') === CLOSED) {
      setStoreClosedMsg(getTernaryValue(message !== NOT_WITHIN_OPERATING_HOURS, message, null));
      setShowAlert(true);
      return;
    }
  }
  setOnModalOpen(false);
  if (type === FROMCONFIRM) {
    setFromFlag(true);
    let payload = {
      unavailableItems,
      priceChangedItems,
      createAddValidateBasket,
      dispatch,
      cartId: cartData?.id,
      tenantId,
    };
    confirmChangesSubmit(payload);
  } else {
    setFromFlag(false);
    //validate basket
    dispatch(validateBasketAction({ data: { id: cartData?.id }, tenantId: tenantId }));
  }
};

const CartPageContainer = props => {
  const { MENU_PLP_CONSTANT } = MENU_PLP_CONSTANT_DATA;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();
  const dispatch = useDispatch();
  const { cartReducer, orderReducer, profileReducer, tenantReducer, storesReducer } = useSelector(data => data);
  const {
    cartData = {},
    isValidated = false,
    isValidateBasketSuccess = false,
    showProductListingModal = false,
  } = getValueOrDefaultObject(cartReducer);
  const showOrderNow = cartData?.requestedDateTime?.isForNow;
  const { validationResult = {} } = getValueOrDefaultObject(cartData);
  const isLoadingVal = useSelector(({ menuReducer: { isLoading } }) => isLoading);
  const flatRes = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const {
    tenantId,
    currencyConversionFactor,
    currencySymbol,
    componentOptions,
    buffertimepmpickup = 30,
    buffertimepmdelivery = 30,
  } = getValueOrDefaultObject(tenantReducer);
  const dispositionConfig = componentOptions?.web?.dispositionConfig;
  const { enableScheduleOrder = false, enableClickCollectScheduleOrder = false } = dispositionConfig;
  const allowScheduleOrderForDispositions =
    componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions ?? [];
  const [cartList, setCartList] = useState([]);
  const [fromFlag, setFromFlag] = useState(false);
  const [updateCartList, setUpdatedCartList] = useState([]);
  const [unavailableItems, setUnavailableItems] = useState([]);
  const [priceChangedItems, setPriceChangedItems] = useState([]);
  const [onModalOpen, setOnModalOpen] = useState(false);
  const [menuCallBack, setMenuCallBack] = useState(null);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { headerData: { pdpBackgroundImage = {} } = {} } = useSelector(
    state => state?.marketConfigReducer?.response || {},
  );
  const exclusionsResponse = useSelector(({ menuReducer: { exclusionsResponse } }) => exclusionsResponse);
  const pdpbackgroundImageData = getBackgroundImagePath(pdpBackgroundImage);
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const { SERVICE_CHANNEL } = MENU_PLP_CONSTANT;
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionNew),
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW)),
    userOrderState.dispositionNew,
  );
  const dispositionOld = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionOld),
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_OLD)),
    userOrderState.dispositionOld,
  );
  const { date = '', time = '', store, type } = getValueOrDefaultObject(dispositionNew);
  const location = useLocation();
  const catalogs =
    storesReducer?.storesWithStatus?.[0]?.summary?.menu?.catalogs?.[0] ||
    (store &&
      store.summary &&
      store.summary.menu &&
      store.summary.menu.catalogs &&
      store.summary.menu.catalogs.length &&
      store.summary.menu.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';
  let segmentedHelpData = null;
  const { cartPage = {}, web = {} } = componentOptions;
  const { shouldCheckDropOffAddress = false } = web;
  const { cartWarningMsg = false } = cartPage;
  const [storeClosedMsg, setStoreClosedMsg] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isModelClosed] = useState(false);
  const [isLoadOrderReducer, setIsLoadOrderReducer] = useState(false);
  const { NA } = MENU_PDP_PAGE_CONSTANTS;
  const getPwaStorageData = useAppSelector(getPWAstorage);

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (dispatch) {
      dispatch(resetPostOrder());
      dispatch(resetOrderAction());
    }
  }, [dispatch]);
  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);
  /**
   * method to setup content data for cart page config
   */
  const allReducerData = useSelector(data => {
    return {
      helpReducerContent: get(data, 'helpReducer', null),
    };
  });

  if (allReducerData.helpReducerContent) {
    segmentedHelpData = getValueOrnull(getFaqData(allReducerData.helpReducerContent));
  }
  const params = useMemo(() => {
    return {
      tenantReducer,
      cartReducer,
      segmentedHelpData,
      storeInfo: getValueOrDefaultObject(dispositionNew && dispositionNew.store),
      dispositionType: getTernaryValue(
        dispositionNew && dispositionNew.type,
        getDispositionTypeOnAPIFormat(dispositionNew?.type),
        getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
      ),
    };
  }, [cartReducer, dispositionNew, segmentedHelpData, tenantReducer]);

  useEffect(() => {
    if (showProductListingModal) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: false,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);

  useEffect(() => {
    if (
      currentItemDetails &&
      userOrderState.cartEditClicked &&
      userOrderState.minipdpData.itemId === currentItemDetails.id
    ) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails, userOrderState.minipdpData.itemId, userOrderState.cartEditClicked]);
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions.includes(params.dispositionType);
  const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrderFlag;
  let fetchMenuPayload = {
    storeId: params.storeInfo?.id,
    channel: SERVICE_CHANNEL,
    service: params.dispositionType,
  };
  const scheduleOrderObject = { enableScheduleOrderFlag, showOrderNow, allowScheduleOrderForDispositions };
  const updatedFetchMenuPayload = saveScheduleDate(fetchMenuPayload, params?.dispositionType, scheduleOrderObject);
  fetchMenuPayload = updatedFetchMenuPayload;
  useEffect(() => {
    let flag = cartIdAndTenantIdExists(cartData, tenantId, menuCallBack);
    const { customerId } = AuthManager.getInstance();
    if (flag && customerId === cartData?.customer?.id) {
      dispatch(
        basketDetailsAction({
          tenantId: tenantId,
          basketId: cartData.id,
        }),
      );
      dispatch(
        fetchMenuAction(
          {
            tenantId: tenantId,
            catalogName: catalogs,
          },
          fetchMenuPayload,
        ),
      );
      setMenuCallBack(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    tenantId,
    cartData?.id,
    catalogs,
    cartData?.customer?.id,
    params.dispositionType,
    params.storeInfo?.id,
    cartReducer?.cartData?.id,
    SERVICE_CHANNEL,
    menuCallBack,
  ]);

  useEffect(() => {
    dispatch(
      getContentHelpCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'supportContent',
          select: 'sys.id,fields',
          'fields.title': 'CartFAQ',
          include: '5',
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userOrderState.dispositionNew?.type) {
      const recommendedProductsPayload = {
        channel: 'web',
        service: getDispositionTypeOnAPIFormat(userOrderState.dispositionNew?.type),
      };
      dispatch(recommendedProductAction(recommendedProductsPayload));
    }
  }, [dispatch, userOrderState.dispositionNew]);
  const service = getDispositionTypeOnAPIFormat(
    dispositionNew?.type ?? tenantReducer.authoredContent?.defaultdisposition,
  );
  let fetchMenuPayloadLocalized = {
    storeId: dispositionNew?.store?.id,
    channel: SERVICE_CHANNEL,
    service: service,
  };
  const scheduleOrderObjectLocalized = { enableScheduleOrderFlag, showOrderNow, allowScheduleOrderForDispositions };
  const updatedFetchMenuPayloadLocalized = saveScheduleDate(
    fetchMenuPayloadLocalized,
    params?.dispositionType,
    scheduleOrderObjectLocalized,
  );
  fetchMenuPayloadLocalized = updatedFetchMenuPayloadLocalized;
  const stringyfyDeposition = JSON.stringify(dispositionNew);
  useEffect(() => {
    setOnModalOpen(false);
    const { showDisposition } = userOrderState.dispositionStateData;
    const { showSearchStore } = userOrderState.searchStoreData;
    const { showScheduleOrderCatering } = userOrderState.scheduleOrderData;
    if (
      !showDisposition &&
      !showSearchStore &&
      !showScheduleOrderCatering &&
      dispositionNew &&
      !isEqualDisposition(dispositionOld, dispositionNew) &&
      !isLoadingVal
    ) {
      //check if all props available && userParams localized
      if (userParams.localized && type !== '' && store !== '' && date !== '' && time !== '') {
        /* Need to uncomment Lines #304 post analysis. This is required only for India  */
        dispatch(
          fetchMenuAction(
            {
              tenantId: tenantId,
              catalogName: catalogs,
            },
            fetchMenuPayloadLocalized,
          ),
        );
        userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: true } });
      }
      userOrderStateDispatch({
        type: DISPOSITION_CHANGED_FLAG,
        value: { dispositionChanged: false },
      });
      userOrderStateDispatch({
        type: STORE_CHANGED_FLAG,
        value: { storeChanged: false },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    stringyfyDeposition,
    userParams,
    CART_STATES_DATA,
    DISPOSITION_CHANGED_FLAG,
    SERVICE_CHANNEL,
    STORE_CHANGED_FLAG,
    catalogs,
    dispatch,
    tenantId,
    tenantReducer.authoredContent?.defaultdisposition,
    userOrderState.dispositionStateData,
    userOrderState.scheduleOrderData,
    userOrderState.searchStoreData,
    userOrderStateDispatch,
  ]);

  useEffect(() => {
    if (flatRes?.itemMapById && currencyConversionFactor && !isLoadingVal) {
      if (cartData?.foodLines?.length > 0) {
        const validationSummaryResult = cartData.foodLines.map(Item => {
          return analyzeFoodLine({
            foodLineItem: Item,
            menuJSONData: flatRes.itemMapById,
            currencyConversionFactor: currencyConversionFactor,
            exclusionsResponse: exclusionsResponse,
            taxLines: cartData.taxLines,
          });
        });
        if (onModalOpen) {
          const validationDefaultSummaryResult = cartData.foodLines.map(Item => {
            return defaultFoodLine(Item, currencyConversionFactor);
          });
          setCartList(validationDefaultSummaryResult);
        } else {
          setCartList(validationSummaryResult);
        }
        setUpdatedCartList(validationSummaryResult);
        let unavailables = validationSummaryResult.filter(item => item.toRemove);
        setUnavailableItems(unavailables);
        let priceChanged = validationSummaryResult.filter(item => item.requireModification);
        setPriceChangedItems(priceChanged);
        checkExclusion(cartData?.recommendedItems, exclusionsResponse, NA);
      } else {
        setUpdatedCartList([]);
        setCartList([]);
        setUnavailableItems([]);
        setPriceChangedItems([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyConversionFactor, cartData, flatRes, onModalOpen, isLoadingVal]);

  const checkStoreStatus = (storeType, scheduleTimeCheck, setOrderScheduleModal) => {
    const payloadData = {
      type: storeType,
      storeDetails: {},
      buffertimepmdelivery,
      buffertimepmpickup,
      cartWarningMsg,
      setStoreClosedMsg,
      setShowAlert,
      setOnModalOpen,
      setFromFlag,
      dispatch,
      unavailableItems,
      priceChangedItems,
      cartData,
      tenantId,
      createAddValidateBasket,
      scheduleTimeCheck,
      setOrderScheduleModal,
      enableScheduleOrder,
      enableClickCollectScheduleOrder: enableClickCollectScheduleOrderFlag,
      isFutureDateTimeOrder: false,
      enableScheduleOrderFlag,
    };
    if (cartWarningMsg) {
      const dataList = createPayloadForStatusCall([store], store?.service, null, shouldCheckDropOffAddress);
      const userTimeSlot = cartReducer?.cartData?.requestedDateTime?.futureDateTime ?? '';
      const payload = {
        storeid: dataList[0]?.storeId,
        service: dataList[0].service,
        channel: dataList[0].channel,
      };
      const finalPayload = userTimeSlot ? { ...payload, futureDateTimeInEpochFormat: userTimeSlot } : payload;
      dispatch(
        getStoreStatusForTimeSaga(
          { data: finalPayload, tenantId: tenantId },
          storeDetails => {
            const storeSummaryDetail = storeDetails?.[0]?.summary;
            const isStoreOrderSchedulingUnavailable = storeOrderSchedulingUnavailable(
              storeDetails?.[0],
              enableScheduleOrderFlag,
              enableClickCollectScheduleOrderFlag,
              false,
            );
            const isFutureTimeDateOrderData = Boolean(
              (isFutureTime(storeDetails?.[0]) || isFutureDate(storeDetails?.[0])) &&
                !isStoreOrderSchedulingUnavailable,
            );
            checkSummaryStatus(storeSummaryDetail, setStoreClosedMsg, setShowAlert);
            setPriceLimitInLocalStorage(storeDetails?.[0]?.summary?.menu);
            setOnModalOpen(false);
            const confirmChangesHandlerPayload = {
              ...payloadData,
              storeDetails,
              isFutureDateTimeOrder: isFutureTimeDateOrderData,
            };
            confirmChangesHandler(confirmChangesHandlerPayload);
          },
          null,
        ),
      );
    } else {
      confirmChangesHandler(payloadData);
    }
  };

  const createAddValidateBasket = async () => {
    //create cart with selected storeinfo
    let newCartItems = [];
    updateCartList.forEach(validationSummaryResultItem => {
      // If this item is to be added to the new cart
      if (!validationSummaryResultItem.toRemove) {
        let addItemObj = {};
        addItemObj.id = validationSummaryResultItem?.newFoodLineItem?.item?.id;
        addItemObj.categoryId = '';
        addItemObj.quantity = validationSummaryResultItem?.newFoodLineItem?.quantity;
        addItemObj.modGrps = validationSummaryResultItem?.newFoodLineItem?.item?.modGrps;
        newCartItems.push(addItemObj);
      }
    });
    dispatch(resetBasketAction());
    let obj = await createBasketData(params.storeInfo, params.dispositionType, profileReducer.customerId);
    tenantId && dispatch(createBasketsAction({ data: obj, tenantId, shouldAddItem: true, addItemList: newCartItems }));
    dispatch(setUserLastActiveTime(new Date()));
  };

  useEffect(() => {
    if (isValidateBasketSuccess) {
      ChannelManager.BindUser(userParams?.loggedIn).then(() => {
        let navigateToCheckOutObj = { fromFlag, history };
        const validationObj = {
          currencyConversionFactor,
          currencySymbol,
          store,
        };
        cartValidationCheck({
          dispatch,
          isValidated,
          navigateToCheckOutObj,
          validationResult,
          validationObj,
          setMenuCallBack,
          basketId: cartData?.id,
          tenantId,
          customerId: profileReducer.customerId,
          setIsLoadOrderReducer,
          getPwaStorageData,
          checkPassStreetNumber: tenantReducer?.componentOptions?.web?.cartPage?.passStreetNoToOrder,
          service: cartReducer?.cartData?.service,
        });
        dispatch(resetValidateBasketAction());
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidateBasketSuccess, validationResult, isValidated, dispatch, history, fromFlag]);

  useEffect(() => {
    if (orderReducer && isLoadOrderReducer) {
      if (orderReducer?.error) {
        // eslint-disable-next-line no-empty
      } else if (isValidObject(orderReducer?.response)) {
        redirectToCheckoutPage(props);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderReducer]);

  const onClickBtnHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowAlert(false);
    triggerCartModel(userOrderStateDispatch, localStorage.getItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS));
  };

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <CartPageComponent
        contentData={params}
        cartListContent={cartList}
        isModalOpen={onModalOpen}
        confirmChangesHandler={checkStoreStatus}
        dispositionData={dispositionNew}
        history={history}
        isModelClosed={isModelClosed}
        isMobile={isMobile}
        pdpbackgroundImageData={pdpbackgroundImageData}
        isShowCreateOrderError={isLoadOrderReducer && orderReducer && orderReducer?.error}
      />

      {showProductListingModal && <ProductListingModalOptions />}
      {getTernaryValue(userOrderState.showCartClearAlert, <ClearCartModule />, null)}
      <AlertContainer
        handleClose={() => setShowAlert(false)}
        showAlert={showAlert}
        onClickBtnHandler={onClickBtnHandler}
        stoerName={store?.summary?.name}
        storeClosedMsg={switchErrorMsg(storeClosedMsg, DOORDASH_NOT_SERVICEABLE)}
        contentMsg={CART_SELECT_STORE_MSG}
      />
    </React.Fragment>
  );
};

export default CartPageContainer;
